export const css = {
	root: 'ojfOL0Vc',
	content: 'aZtxleH3',
	title: 'wBqwBkny',
	subtitle: 'T1zcAji-',
	actions: 'HpVIR2XG',
	' _key': 'card/pretestReview'
};

export default css;
